import { STEP_SECONDS } from './constants';
export class FixedStepClock {
  private previous: number | null=null;
  private accumulator=0;
  reset(): void {this.previous=null;this.accumulator=0;}
  advance(timestamp: number, step: ()=>void): number {
    if (this.previous===null) {this.previous=timestamp;return 0;}
    const delta=Math.max(0,Math.min(100,timestamp-this.previous));this.previous=timestamp;
    this.accumulator+=delta/1000;
    let count=0;
    while (this.accumulator+1e-10>=STEP_SECONDS && count<7) {step();this.accumulator-=STEP_SECONDS;count++;}
    return count;
  }
}
